import { render, staticRenderFns } from "./SearchPanel.vue?vue&type=template&id=87ab6a80&"
import script from "./SearchPanel.vue?vue&type=script&lang=js&"
export * from "./SearchPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports